import React from 'react'
import PropTypes from 'prop-types'

export default class JobModuleBase extends React.Component {

  static propTypes = {
    moduleRef: PropTypes.string,
    jobInfo: PropTypes.shape({
      id: PropTypes.string
    })
  }

  getCommonModulesDbPath = () => {
    return `events/${this.props.jobInfo.id}/commonInfo`
  }

  getExtendedModulesDbPath = () => {
    return `events/${this.props.jobInfo.id}/extendedInfo/modules/${this.props.moduleRef}`
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/JobModuleBase.js